export enum StimulusType {
    ACTION_COLOR = "action_color",
    ACTION_ARROW = "action_arrow",
}

export const ARROW_HIDE_COMMAND = "command_arrow_hide";

export enum ArrowDirection {
    LEFT = "left",
    RIGHT = "right",
}

export const arrowStimulusMessage = (direction: ArrowDirection): string =>
    `${StimulusType.ACTION_ARROW}_${direction}`;

export const parseArrowDirection = (message: string): ArrowDirection | undefined => {
    const prefix = `${StimulusType.ACTION_ARROW}_`;
    if (!message.startsWith(prefix)) return undefined;
    const direction = message.slice(prefix.length);
    return Object.values(ArrowDirection).find((value) => value === direction);
};
